/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Subscription_NoInputs */

const en_admin_subscriptions_subscription_no = /** @type {(inputs: Admin_Subscriptions_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription No`)
};

const zh_admin_subscriptions_subscription_no = /** @type {(inputs: Admin_Subscriptions_Subscription_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅号`)
};

/**
* | output |
* | --- |
* | "Subscription No" |
*
* @param {Admin_Subscriptions_Subscription_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_subscription_no = /** @type {((inputs?: Admin_Subscriptions_Subscription_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Subscription_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_subscription_no(inputs)
	return zh_admin_subscriptions_subscription_no(inputs)
});
export { admin_subscriptions_subscription_no as "admin.subscriptions.subscription_no" }